import type {
  BigIntToString,
  PermitBatch,
  PermitSingle,
} from "@eulerxyz/core-sdk"
import type { Address, Hex } from "viem"
import {
  type Asset,
  type TransactionItemBase,
  type TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"

export type PermitTransactionLabel =
  | TransactionLabel.PERMIT
  | TransactionLabel.PERMIT_BATCH

export type PermitTransactionBase = {
  label: PermitTransactionLabel
  permit: BigIntToString<PermitSingle | PermitBatch>
  address: Address
  signature: Hex
}

export function isPermitTransactionItem(
  item?: TransactionItemUnion,
): item is PermitTransactionItem {
  return (
    item?.label === TransactionLabel.PERMIT ||
    item?.label === TransactionLabel.PERMIT_BATCH
  )
}

export type PermitSingleTransactionItem = PermitTransactionItem & {
  label: TransactionLabel.PERMIT
  permit: BigIntToString<PermitSingle>
}
export function isPermitSingleTransactionItem(
  item?: TransactionItemUnion,
): item is PermitSingleTransactionItem {
  return item?.label === TransactionLabel.PERMIT
}

export type PermitBatchTransactionItem = PermitTransactionItem & {
  label: TransactionLabel.PERMIT_BATCH
  permit: BigIntToString<PermitBatch>
}

export function isPermitBatchTransactionItem(
  item?: TransactionItemUnion,
): item is PermitBatchTransactionItem {
  return item?.label === TransactionLabel.PERMIT_BATCH
}

export type PermitTransactionItem = TransactionItemBase<
  PermitTransactionBase,
  Asset
>
